import { render, staticRenderFns } from "./FAQAppSetting.vue?vue&type=template&id=16856534&scoped=true"
import script from "./FAQAppSetting.vue?vue&type=script&lang=js"
export * from "./FAQAppSetting.vue?vue&type=script&lang=js"
import style0 from "./FAQAppSetting.vue?vue&type=style&index=0&id=16856534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16856534",
  null
  
)

export default component.exports